import { useState } from "react";

interface Props {
  projectId: string;
  initialUrl: string | null;
  onSave: (url: string) => Promise<void>;
  onCancel: () => void;
}

export function ProjectDevServerForm({ initialUrl, onSave, onCancel }: Props) {
  const [url, setUrl] = useState(initialUrl ?? "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  function isValid(u: string) {
    try {
      const parsed = new URL(u);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
      return false;
    }
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!isValid(url)) {
      setError("Must be http:// or https://");
      return;
    }
    setSaving(true);
    try {
      await onSave(url);
    } catch (err) {
      setError(String(err));
    } finally {
      setSaving(false);
    }
  }

  return (
    <form className="project-devserver-form" onSubmit={handleSubmit}>
      <label>
        Dev server URL
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="http://localhost:5173"
          autoFocus
        />
      </label>
      {error && <div className="project-devserver-form__err">{error}</div>}
      <div className="project-devserver-form__actions">
        <button type="button" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" disabled={saving}>
          Save
        </button>
      </div>
    </form>
  );
}
